import { Component, OnInit } from '@angular/core';
import { Logger } from '../../../@utility';
import { Router } from '@angular/router';

//Logger Instance
const log = new Logger('Login');
interface iRealm {
  name: string;
  value: string;
}
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  userEmail: string;
  password: string;
  realm: iRealm[];
  selectedRealm: iRealm;
  constructor(private router: Router) {
    this.selectedRealm = {
      name: 'Test',
      value: 'Test',
    };
  }

  ngOnInit(): void {
    log.debug('init');
  }

  onClickLogin(): void {
    if (this.selectedRealm !== undefined) {
      localStorage.setItem('realm', this.selectedRealm.value);
      this.router.navigate(['/main/dashboard']);
    }
  }
}
